/**
 * La marca que el servidor deja en el HTML cuando quien pide la página es un rastreador y
 * el SSR cargó sus datos sin fallos (ver `server/api-util/crawler.js`). Con ella, el
 * navegador del bot no repite en la hidratación las peticiones cuyo resultado ya viene
 * dentro de `window.__PRELOADED_STATE__`.
 *
 * **Se consume una sola vez.** Vale para la primera carga, que es la que el servidor acaba
 * de resolver; si después hubiera una navegación dentro de la aplicación, esa ya no la ha
 * resuelto nadie y tiene que cargar sus datos como siempre.
 */

let skipAvailable =
  typeof window !== 'undefined' &&
  // eslint-disable-next-line no-underscore-dangle
  window.__SKIP_CLIENT_DATA_LOAD__ === true;

/**
 * ¿Puede saltarse la carga de datos de esta primera pantalla? Devuelve `true` como máximo
 * una vez por carga de página.
 */
export const consumeSkipInitialDataLoad = () => {
  if (!skipAvailable) {
    return false;
  }
  skipAvailable = false;
  return true;
};

// Para los tests.
export const resetSkipInitialDataLoad = value => {
  skipAvailable = value === true;
};
